import request from '@/utils/request'

// 查询家政类型列表
export function queryHousekeepingType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.queryHousekeepingType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加家政类型
export function saveHousekeepingType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.saveHousekeepingType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新家政类型
export function updateHousekeepingType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.updateHousekeepingType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除家政类型
export function deleteHousekeepingType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.deleteHousekeepingType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询店铺列表
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询商品列表
export function queryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}